module.exports = __webpack_public_path__ + "static/img/9.7f4fc99.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/zh/9.png
// module id = fXw+
// module chunks = 0